<template>
    <div class="" style="">
        <router-view></router-view>
    </div>
</template>

<script>
    import old from '@/assets/sass/old.lazy.scss'
    export default {
      created () {
        old.use()
      },

      beforeDestroy () {
        old.unuse()
      }
    }
</script>
